exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-intershop-index-jsx": () => import("./../../../src/pages/intershop/index.jsx" /* webpackChunkName: "component---src-pages-intershop-index-jsx" */),
  "component---src-pages-intersocial-index-jsx": () => import("./../../../src/pages/intersocial/index.jsx" /* webpackChunkName: "component---src-pages-intersocial-index-jsx" */),
  "component---src-pages-marketplace-index-jsx": () => import("./../../../src/pages/marketplace/index.jsx" /* webpackChunkName: "component---src-pages-marketplace-index-jsx" */)
}

